import { SlidersVertical } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const RulesIcon = DeckardIconWrapper({ Icon: SlidersVertical });
